var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInactive2 = function SvgInactive2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.071 8h-3.214V3.1c0-1.16-.863-2.1-1.928-2.1H8.07c-1.065 0-1.928.94-1.928 2.1v2.1H2.929C1.863 5.2 1 6.14 1 7.3v6.3c0 .773.576 1.4 1.286 1.4h15.428c.71 0 1.286-.627 1.286-1.4v-3.5c0-1.16-.863-2.1-1.929-2.1ZM2.286 7.3c0-.387.288-.7.643-.7h3.214v7H2.286V7.3Zm5.143-4.2c0-.387.287-.7.642-.7h3.858c.355 0 .642.313.642.7v10.5H7.43V3.1Zm6.428 10.5V9.4h3.214c.355 0 .643.313.643.7v3.5h-3.857Z",
    fill: "#777",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 0.4
  })));
};
export default SvgInactive2;